module.exports = __webpack_public_path__ + "img/blank-funnel.8d171f19.svg";